import React, { createContext, useState, useEffect, ReactNode } from "react";
import { getFrontEndSystemPreference } from "../../service/Scope/Scope";
import { getLicenseWithStatus } from "../../service/License/License";

interface SystemPreferenceContextProvider {
  children: ReactNode;
}

// Define the type for your context
type SystemPreferenceContextType = {
  preferenceData: any | null;
  setPreferenceData: React.Dispatch<React.SetStateAction<any | null>>;
  setCompanyToken: React.Dispatch<React.SetStateAction<string>>;
  getLicenseWithStatusApi: any;
};

// Create a new context
export const systemPreferenceContext =
  createContext<SystemPreferenceContextType>({
    preferenceData: null,
    setPreferenceData: () => null,
    setCompanyToken: () => null,
    getLicenseWithStatusApi: () => {},
  });

// Create a provider component
export const SystemPreferenceContextProvider: React.FC<
  SystemPreferenceContextProvider
> = ({ children }) => {
  const [preferenceData, setPreferenceData] = useState<any | null>(null);
  const [companyToken, setCompanyToken] = useState<string>(
    localStorage.getItem("companyToken") ?? "",
  );
  useEffect(() => {
    // Fetch data from the API
    const fetchData = async () => {
      try {
        const data: any = await getFrontEndSystemPreference();
        setPreferenceData(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (companyToken) {
      getLicenseWithStatusApi();
    }
  }, [companyToken]);
  const getLicenseWithStatusApi = async () => {
    const res = await getLicenseWithStatus("");
    if (res?.status === 200) {
      localStorage.setItem(
        "licenseWithStatus",
        JSON.stringify(res?.data?.data),
      );
      return res?.data?.data;
    }
  };

  return (
    <systemPreferenceContext.Provider
      value={{
        preferenceData,
        setPreferenceData,
        setCompanyToken,
        getLicenseWithStatusApi,
      }}
    >
      {children}
    </systemPreferenceContext.Provider>
  );
};
